import React from 'react';
import { Link } from 'react-router-dom';
import '../homepage.css';  // Ensure you have the CSS file

const HomePage = () => {
  const userName = localStorage.getItem('userName'); // Get the user's name from localStorage
  return (
    <div className="homepage-container">
      <h1 className="homepage-title">AddressKeeper</h1>
      {userName && <div className="welcome-message">Welcome, {userName}</div>} {/* Display the user's name */}
      <div className="action-buttons-container">
        <Link to="/add-address" className="action-button add-address-button">Add Address</Link>
        <Link to="/fetch-address" className="action-button fetch-address-button">Fetch Address</Link>
      </div>
    </div>
  );
}

export default HomePage;